import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import PageHeader from '@/pages/people-people/PageHeader';
import useRouter from '@/hooks/useRouter';
import Redirect from '@/components/Redirect';
import { isExpired } from '@/utils/dateTimeUtils';

function Header(props) {
  const { children } = props;

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Your Events</title>
      </Helmet>
      <PageHeader
        title="Your Events"
      />
      <div className="space-y-8">
        {children}
      </div>
    </div>
  );
}

Header.propTypes = {
  children: PropTypes.node
};

export default function Layout() {
  const { match, location } = useRouter();

  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  });

  if (event.state === PayloadStates.FETCHING) {
    return (
      <Header>
        <Loader className="mx-7" />
      </Header>
    );
  }

  if (isExpired(event.data.date)) {
    if (
      event.data.completed ||
      event.data.cancelled
    ) {
      return (
        <Header>
          <Redirect to={{
            pathname: '/my-past',
            search: location.search
          }} />
        </Header>
      );
    } else {
      return (
        <Header>
          <Redirect to={{
            pathname: '/my-expired',
            search: location.search
          }} />
        </Header>
      );
    }
  }

  return (
    <Header>
      <Redirect to={{
        pathname: '/my-leading',
        search: location.search
      }} />
    </Header>
  );
}
